import type { BimActKc2ListItemData } from 'gql/graphql';
import { BimActKc2GroupTypeEnum } from 'gql/graphql';
import { WorkOrderActsKc2ListTable } from 'pages/Project/Common/ActsKC2ListContainer/';

import { useMemo } from 'react';

import type { IActKc2OtherItem } from '../BimWorkOrderActsKc2List';

import { useBimActsKc2GroupManager, useBimActsKc2ListData } from './hooks';

const defaultColDef = {
    resizable: true,
    wrapHeaderText: true,
    spanHeaderHeight: true,
};

export const BimWorkOrderActsKc2ListTable = ({
    workOrderId,
    activeGroupTypeId,
    onOpenOtherActKc2Details,
    onOpenActsSmrDetail,
}: {
    workOrderId: number;
    activeGroupTypeId: BimActKc2GroupTypeEnum | undefined | null;
    onOpenOtherActKc2Details: (act: IActKc2OtherItem) => void;
    onOpenActsSmrDetail: (data: Partial<BimActKc2ListItemData>) => void;
}) => {
    const groupManagerAvailable = useMemo(
        () => activeGroupTypeId === BimActKc2GroupTypeEnum.Custom,
        [activeGroupTypeId],
    );

    const {
        actKc2List,
        totalItemsCount,
        fetchedDataCount,
        tableColumns,
        noRowsTemplate,
        refreshActListData,
        isDeleteOpened,
        confirmDeletion,
        cancelDeletion,
        groupEditId,
        handlerCloseEditGroup,
        changeOrderHandler,
        handleTableSettingsConfirm,
        tableSettingsColumns,
        isColumnVisible,
    } = useBimActsKc2ListData({
        workOrderId,
        activeGroupTypeId,
        onOpenOtherActKc2Details,
        onOpenActsSmrDetail,
    });

    const {
        control,
        groupManagerColumns,
        groupManagerData,
        groupManagerOpened,
        handleToggleModalState,
        isLoading,
        handleSaveGroup,
        isCommit,
        isConfirmDisabled,
        isFormDirty,
    } = useBimActsKc2GroupManager({
        workOrderId,
        actKC2GroupId: groupEditId,
        refreshActListData,
        handlerCloseEditGroup,
    });

    return (
        <WorkOrderActsKc2ListTable
            groupManagerControl={control}
            actKc2List={actKc2List}
            tableColumns={tableColumns}
            groupManagerData={groupManagerData}
            groupManagerColumns={groupManagerColumns}
            groupManagerAvailable={groupManagerAvailable}
            isDeleteOpened={isDeleteOpened}
            confirmDeletion={confirmDeletion}
            cancelDeletion={cancelDeletion}
            groupManagerOpened={groupManagerOpened}
            handleSaveGroup={handleSaveGroup}
            defaultColDef={defaultColDef}
            handleToggleModalState={handleToggleModalState}
            isLoading={isLoading}
            isCommit={isCommit}
            isConfirmDisabled={isConfirmDisabled}
            isFormDirty={isFormDirty}
            noRowsTemplate={noRowsTemplate}
            fetchedDataCount={fetchedDataCount}
            totalItemsCount={totalItemsCount}
            changeDataOrderHandler={changeOrderHandler}
            isColumnVisible={isColumnVisible}
            tableSettingsColumns={tableSettingsColumns}
            handleTableSettingsConfirm={handleTableSettingsConfirm}
            isEdit={!!groupEditId}
            tableContext={{
                tableUniqueId: 'bimActList',
            }}
        />
    );
};
BimWorkOrderActsKc2ListTable.displayName = 'BimWorkOrderActsKc2ListTable';
